import { DefineComponentProps, transformHexToRgba } from 'utils'
import './Tag.scss'

export type TagProps = {
  color: string
  bgColor?: string
}

export const Tag = defineComponent<TagProps>({
  props: DefineComponentProps<TagProps>(['color', 'bgColor']),
  setup(props, { slots }) {
    return () => (
      <span class="tag" style={{ backgroundColor: props.bgColor || transformHexToRgba(props.color, 0.1), color: props.color }}>
        {slots.default?.()}
      </span>
    )
  },
})
